import { useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { Button } from './ui/button';
import { resolveTheme, toggleTheme, type Theme } from '../lib/theme';

export default function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => resolveTheme());

  return (
    <Button
      type="button"
      size="icon"
      variant="outline"
      className="h-8 w-8"
      onClick={() => setTheme((current) => toggleTheme(current))}
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-pressed={theme === 'dark'}
    >
      {theme === 'dark' ? <Sun /> : <Moon />}
    </Button>
  );
}
